import { useMutation } from '@tanstack/react-query';
import apiClient from '../services/apiService';
import { toast } from 'react-toastify';

export const useDeleteManualBlockedDateById = () => {

  return useMutation({
    mutationFn: async ({ dateId, propertyId }) => {
      const response = await apiClient.delete(
        `/api/properties/manual-blocked-dates/${dateId}`
      );
      return response;
    },
    onSuccess: (response, variables) => {
      toast.success(response?.data?.message || 'Date unblocked successfully');
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
    onError: (error) => {
      toast.error(error.message || 'Failed to unblock date');
    },
  });
};
